<template>
  <div class="copyright-warning" v-if="!isSystemAdmin">
    <div class="warning-header">
      <i class="fa-solid fa-triangle-exclamation"></i>
      <span>AVISO DE DIREITOS AUTORAIS E PROTEÇÃO DE DADOS</span>
    </div>
    <div class="warning-body">
      <p>
        Todo o conteúdo disponibilizado nesta plataforma (vídeos, PDFs, simulados e textos) é de propriedade exclusiva do Projeto Asas e protegido pela <strong>Lei de Direitos Autorais (Lei nº 9.610/98)</strong>.
      </p>
      <p>
        É terminantemente <strong>proibida</strong> a cópia, gravação de tela, reprodução, compartilhamento ou comercialização não autorizada de qualquer material aqui presente. O plágio e a pirataria violam os direitos morais e patrimoniais dos autores.
      </p>
      <p>
        <strong>Atenção:</strong> Nosso sistema possui tecnologias de rastreamento e marcas d'água dinâmicas associadas ao seu usuário. Conforme o <strong>Artigo 184 do Código Penal Brasileiro</strong>, a violação de direitos autorais é crime, sujeito a pena de detenção de 3 meses a 1 ano, ou multa. Caso a cópia seja feita com o intuito de lucro (venda ilegal), a pena de reclusão é agravada, podendo chegar de <strong>2 a 4 anos</strong>.
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CopyrightWarning',
  computed: {
    ...mapGetters(['isSystemAdmin'])
  }
}
</script>

<style scoped>
.copyright-warning {
  margin: 20px auto;
  max-width: 1000px;
  background-color: rgba(220, 53, 69, 0.1);
  border: 1px solid rgba(220, 53, 69, 0.5);
  border-radius: 12px;
  padding: 20px;
  color: #fff;
  font-family: 'Inter', sans-serif;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  z-index: 10;
  position: relative;
  margin-top: 5%;
}

.warning-header {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #ff4d4f;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 15px;
}

.warning-body p {
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 1.5;
  color: #e0e0e0;
  text-align: justify;
}

.warning-body p:last-child {
  margin-bottom: 0;
}
</style>
